import React from "react";
import { LanguageLocaleEnum, LeagueListElement, TeamPosition } from "../../../client/api";
import { showTranslated, translate } from "../../../config/translator";
import RoundedRectangle from "../RoundedRectangle";

type PlayerGeneralInfoProps = {
  height: number | null | undefined;
  age: number | null;
  footLabel: string | null;
  mainTeamPosition: TeamPosition | null;
  mainLeague: LeagueListElement | null;
  l: LanguageLocaleEnum;
};

const PlayerGeneralInfo: React.FC<PlayerGeneralInfoProps> = ({
  height,
  age,
  footLabel,
  mainTeamPosition,
  mainLeague,
  l
}) => (
  <RoundedRectangle
    className="rounded-xl bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark"
    hasBorder
    hasTitle
    titleType="upLeft"
    titleKey="general"
  >
    <div className="px-6 xl:px-8 pt-4 pb-1 xl:pb-2">
      <div className="grid grid-cols-3 gap-4 mb-2">
        <div className="flex flex-col items-center">
          <span className="text-lg text-font dark:text-font-dark">
            {height ? `${height} cm` : "-"}
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-lg text-font dark:text-font-dark">
            {age ?? "-"}
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-lg text-font dark:text-font-dark">
            {footLabel ?? "-"}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div className="flex flex-col items-center">
          <span className="text-xs text-font-600 dark:text-font-600-dark text-center">
            {translate("height", l)}
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-xs text-font-600 dark:text-font-600-dark text-center">
            {translate("age", l)}
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-xs text-font-600 dark:text-font-600-dark text-center">
            {translate("preferredFoot", l)}
          </span>
        </div>
      </div>

      {mainTeamPosition && (
        <RoundedRectangle
          className="rounded-lg border border-light-gray dark:border-light-gray-dark -mx-4 xl:-mx-6"
          hasBorder
          hasTitle={false}
        >
          <div className="px-4 py-3">
            {mainTeamPosition.playerPosition && (
              <div className="text-sm text-font dark:text-font-dark text-center mb-2">
                {showTranslated(mainTeamPosition.playerPosition.translation, l)}
              </div>
            )}
            <div className="text-xs text-font-600 dark:text-font-600-dark text-center">
              {translate("position", l)}
              {mainTeamPosition.team && (
                <>
                  <span className="mx-2 text-font-600 dark:text-font-600-dark">|</span>
                  {showTranslated(mainTeamPosition.team.name, l)}
                </>
              )}
              {mainLeague && (
                <>
                  <span className="mx-2 text-font-600 dark:text-font-600-dark">|</span>
                  {showTranslated(mainLeague.name, l)}
                </>
              )}
            </div>
          </div>
        </RoundedRectangle>
      )}
    </div>
  </RoundedRectangle>
);

export default PlayerGeneralInfo;

